import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import Index from '@/components/Index'
import OpenPay from '@/components/OpenPay'
import OrderList from '@/components/OrderManage/OrderList'
import Contract from '@/components/ContractManagement/Contract'
import AddOutbound from '@/components/ContractManagement/AddOutbound'
import store from '@/components/DistributorManage/store'
import productList from '@/components/DistributorManage/productList'
import productListadd from '@/components/DistributorManage/productListadd'
import top from '@/components/ContractManagement/top'
import topadd from '@/components/DistributorManage/topadd'
import topeidt from '@/components/DistributorManage/topeidt'
import topdetail from '@/components/ContractManagement/topdetail'
import PurchaseOrderList from '@/components/ContractManagement/PurchaseOrderList'
import AddPurchaseOrder from '@/components/ContractManagement/AddPurchaseOrder'
import EditPurchaseOrder from '@/components/ContractManagement/EditPurchaseOrder'
import PurchaseOrderDetail from '@/components/ContractManagement/PurchaseOrderDetail'

import deposit from '@/components/ContractManagement/deposit'
import depositdetail from '@/components/ContractManagement/depositdetail'

import auditdeposit from '@/components/DistributorManage/auditdeposit'

import Outbound from '@/components/ContractManagement/Outbound'

import outboundsubmit from '@/components/ContractManagement/outboundsubmit'

import OutboundDetail from '@/components/ContractManagement/OutboundDetail'

import auditcontract from '@/components/DistributorManage/auditcontract'

import clientcontract from '@/components/DistributorManage/clientcontract'

import contractdetail from '@/components/ContractManagement/contractdetail'

import contractReviews from '@/components/ContractManagement/contractReviews'
import depositReviews from '@/components/ContractManagement/depositReviews'
import OutboundReviews from '@/components/ContractManagement/OutboundReviews'

import summary from '@/components/OrderManage/summary '

import OrderListsummary from '@/components/OrderManage/OrderListsummary'

import OrderDetailsummary from '@/components/OrderManage/OrderDetailsummary'

import OrderListServiceProvider from '@/components/OrderManage/OrderListServiceProvider'
import OrderListServiceProviderTeam from '@/components/OrderManage/OrderListServiceProviderTeam'
import OrderReview from '@/components/OrderManage/OrderReview'
import StockInformation from '@/components/OrderManage/StockInformation'
import AbnormalOrderList from '@/components/OrderManage/AbnormalOrderList'
import OrderInterception from '@/components/OrderManage/OrderInterception'
import StoreList from '@/components/StoreManage/StoreList'
import OwnerList from '@/components/StoreManage/OwnerList'
import SelesClerkList from '@/components/StoreManage/SelesClerkList'
import StoreGoods from '@/components/CommoditiesList/StoreGoods'
import ClassifiedManagement from '@/components/MallPageSetting/ClassifiedManagement'
import ClassManagement from '@/components/MallPageSetting/ClassManagement'
import BrandManagement from '@/components/CommoditiesList/BrandManagement'

import GoodsList from '@/components/CommoditiesList/GoodsList'
import AddGoods from '@/components/CommoditiesList/AddGoods'
import EditGoods from '@/components/CommoditiesList/EditGoods'
import WarehouseInfo from '@/components/Settings/WarehouseInfo'
import PointWarehouse from '@/components/Settings/PointWarehouse'
import SeriesManagement from '@/components/CommoditiesList/SeriesManagement'
import BankCardSettings from '@/components/EssentialInformation/BankCardSettings'
import ChangePassword from '@/components/EssentialInformation/ChangePassword'
import OrderManage from '@/components/DistributionMallManage/OrderManage'
import GroupOrderList from '@/components/GroupManage/GroupOrderList'
import DistributorList from '@/components/DistributorManage/DistributorList'
import CustomerService from '@/components/DistributorManage/CustomerService'
import EditOutbound from '@/components/ContractManagement/EditOutbound'
import OutboundList from '@/components/ContractManagement/OutboundList'
import topOrderAddList from '@/components/ContractManagement/topOrderAddList'
import topOrderAddListModify from '@/components/ContractManagement/topOrderAddListModify'

import topReviews from '@/components/ContractManagement/topReviews'
import topList from '@/components/ContractManagement/topList'

import ContractList from '@/components/ContractManagement/ContractList'
import depositList from '@/components/ContractManagement/depositList'

import AccounList from '@/components/AccountManage/AccounList'
import PaySettings from '@/components/Settings/PaySettings'
import DistributorCustom from '@/components/Settings/DistributorCustom'
import BannerManagement from '@/components/MallPageSetting/BannerManagement'
import ProductBannerManagement from '@/components/MallPageSetting/ProductBannerManagement'
import LogoManagement from '@/components/MallPageSetting/LogoManagement'
import ProductLogoManagement from '@/components/MallPageSetting/ProductLogoManagement'
import PageManagement from '@/components/MallPageSetting/PageManagement'
import ProductPageManagement from '@/components/MallPageSetting/ProductPageManagement'
import InfoSynchronization from '@/components/CommoditiesList/InfoSynchronization'
import InfoDetail from '@/components/CommoditiesList/InfoDetail'
import InfoDetailed from '@/components/CommoditiesList/InfoDetailed'
import InfoAttribute from '@/components/CommoditiesList/InfoAttribute'
import PackManagement from '@/components/GroupManage/PackManagement'
import PackPrice from '@/components/GroupManage/PackPrice'
import PackDetail from '@/components/GroupManage/PackDetail'
import GoodsShelves from '@/components/DistributorManage/GoodsShelves'
import GoodsShelvesDetail from '@/components/DistributorManage/GoodsShelvesDetail'
import AddDistributor from '@/components/DistributorManage/AddDistributor'
import DistributorDetail from '@/components/DistributorManage/DistributorDetail'
import OrderDetail from '@/components/OrderManage/OrderDetail'
import OrderReviewDetail from '@/components/OrderManage/OrderReviewDetail'
import TopNavSetting from '@/components/MallPageSetting/TopNavSetting'
import StoreDetail from '@/components/StoreManage/StoreDetail'
import SelesDetail from '@/components/StoreManage/SelesDetail'
import AssociatedGoods from '@/components/PCMallManage/AssociatedGoods'
import EditDistributor from '@/components/DistributorManage/EditDistributor'
import RelatedGoods from '@/components/PCMallManage/RelatedGoods'
import RoleList from '@/components/DistributorManage/RoleList'
import MallSettingMenu from '@/components/MallSettingMenu'
import O2OSettingMenu from '@/components/O2OSettingMenu'
import O2OLogoManagement from '@/components/O2OShopSetting/O2OLogoManagement'
import O2OBannerManagement from '@/components/O2OShopSetting/O2OBannerManagement'
import O2OClassifiedManagement from '@/components/O2OShopSetting/O2OClassifiedManagement'
import O2OPageManagement from '@/components/O2OShopSetting/O2OPageManagement'
import O2OAssociatedGoods from '@/components/O2OShopSetting/O2OAssociatedGoods'
import O2OGoodsShelves from '@/components/O2OShopSetting/O2OGoodsShelves'
import O2OGoodsShelvesDetail from '@/components/O2OShopSetting/O2OGoodsShelvesDetail'
import AddAgreement from '@/components/AgreementManage/AddAgreement'

// 合同&&保证金
import DepositCash from '@/components/ContractManagement/DepositCash'
import ContractReviewList from '@/components/ContractManagement/ContractReviewList'
import ContractReviewDetail from '@/components/ContractManagement/ContractReviewDetail'

// 银行配置
import Bank from '@/components/Settings/Bank'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    redirect: '/login'
  },
  {
    path: '/login',
    name: 'Login',
    component: Login

  },
  {
    path: '/openpay',
    name: 'OpenPay',
    component: OpenPay

  },
  {
    path: '/home',
    name: 'Home',
    component: Home,
    redirect: '/index',
    children: [ // 这里就是二级路由的配置
      {
        path: '/transregional',
        name: 'transregional',
        component: () => import('@/components/Transregional/index.vue')
      },
      {
        default: Index,
        path: '/index',
        name: 'Index',
        component: Index
      },
      {
        path: '/orderlist',
        name: 'OrderList',

        component: OrderList
      },
      {
        path: '/orderGiftList',
        name: 'OrderGiftList',
        component: () => import('@/components/OrderManage/orderGiftList')
      },
      {
        path: '/feeSplittingRules',
        name: 'FeeSplittingRules',
        component: () => import('@/components/FeeSplitting/Rules')
      },
      {
        path: '/feeSplittingAgainst',
        name: 'FeeSplittingAgainst',
        component: () => import('@/components/FeeSplitting/Against')
      },
      {
        path: '/feeSplittingWays',
        name: 'FeeSplittingWays',
        component: () => import('@/components/FeeSplitting/Ways')
      },
      {
        path: '/undertakesToPay',
        name: 'UndertakesToPay',
        component: () => import('@/components/FeeSplitting/Undertakes')
      },
      {
        path: '/orderListServiceProvider',
        name: 'OrderListServiceProvider',
        component: OrderListServiceProvider
      },
      {
        path: '/orderListServiceProviderTeam',
        name: 'orderListServiceProviderTeam',
        component: OrderListServiceProviderTeam
      },
      {
        path: '/contract',
        name: 'Contract',
        component: Contract
      },
      {
        path: '/top',
        name: 'top',
        component: top
      },
      {
        path: '/topdetail',
        name: 'topdetail',
        component: topdetail
      },
      {
        path: '/addoutbound',
        name: 'AddOutbound',
        component: AddOutbound
      },
      {
        path: '/store',
        name: 'store',
        component: store
      },
      {
        path: '/productList',
        name: 'productList',
        component: productList
      },
      {
        path: '/productListadd',
        name: 'productListadd',
        component: productListadd
      },
      {
        path: '/deposit',
        name: 'deposit',
        component: deposit
      },
      {
        path: '/depositdetail',
        name: 'depositdetail',
        component: depositdetail
      },
      {
        path: '/auditdeposit',
        name: 'auditdeposit',
        component: auditdeposit
      },
      {
        path: '/outbound',
        name: ' Outbound',
        component: Outbound
      },
      {
        path: '/outboundsubmit',
        name: 'outboundsubmit',
        component: outboundsubmit
      },
      {
        path: '/outbounddetail',
        name: 'OutboundDetail',
        component: OutboundDetail
      },
      {
        path: '/auditcontract',
        name: 'auditcontract',
        component: auditcontract
      },
      {
        path: '/clientcontract',
        name: 'clientcontract',
        component: clientcontract
      },
      {
        path: '/contractdetail',
        name: 'contractdetail',
        component: contractdetail
      },
      {
        path: '/summary',
        name: 'summary ',
        component: summary
      },
      {
        path: '/topadd',
        name: 'topadd ',
        component: topadd
      },
      {
        path: '/topeidt',
        name: 'topeidt',
        component: topeidt
      },
      {
        path: '/purchaseorderlist',
        name: 'PurchaseOrderList',
        component: PurchaseOrderList
      },
      {
        path: '/addpurchaseorder',
        name: 'AddPurchaseOrder',
        component: AddPurchaseOrder
      },
      {
        path: '/editpurchaseorder',
        name: 'EditPurchaseOrder',
        component: EditPurchaseOrder
      },
      {
        path: '/purchaseorderdetail',
        name: 'PurchaseOrderDetail',
        component: PurchaseOrderDetail
      },
      {
        path: '/OrderListsummary',
        name: 'OrderListsummary',
        component: OrderListsummary
      },
      {
        path: '/OrderDetailsummary',
        name: 'OrderDetailsummary',
        component: OrderDetailsummary
      },
      {
        path: '/orderreview',
        name: 'OrderReview',
        component: OrderReview
      },
      {
        path: '/storelist',
        name: 'StoreList',
        component: StoreList
      },
      {
        path: '/ownerlist',
        name: 'OwnerList',
        component: OwnerList
      },
      {
        path: '/storegoods',
        name: 'StoreGoods',
        component: StoreGoods
      },
      {
        path: '/stockinformation',
        name: 'StockInformation',
        component: StockInformation
      },
      {
        path: '/bankcardsettings',
        name: 'BankCardSettings',
        component: BankCardSettings
      },
      {
        path: '/changepassword',
        name: 'ChangePassword',
        component: ChangePassword
      },
      {
        path: '/abnormalorderList',
        name: 'AbnormalOrderList',
        component: AbnormalOrderList
      },
      {
        path: '/selesclerklist',
        name: 'SelesClerkList',
        component: SelesClerkList
      },
      {
        path: '/brandmanagement',
        name: 'BrandManagement',
        component: BrandManagement
      },
      {
        path: '/seriesmanagement',
        name: 'SeriesManagement',
        component: SeriesManagement
      },
      {
        path: '/orderinterception',
        name: 'OrderInterception',
        component: OrderInterception
      },
      {
        path: '/ordermanage',
        name: 'OrderManage',
        component: OrderManage
      },
      {
        path: '/grouporderlist',
        name: 'GroupOrderList',
        component: GroupOrderList
      },
      {
        path: '/distributorlist',
        name: 'DistributorList',
        component: DistributorList
      },
      {
        path: '/order-check',
        name: 'OrderCheck',
        component: () => import('@/components/OrderManage/OrderCheck')
      },
      {
        path: '/customerService',
        name: 'customerService',
        component: CustomerService
      },
      {
        path: '/accounlist',
        name: 'AccounList',
        component: AccounList
      },
      {
        path: '/paysettings',
        name: 'PaySettings',
        component: PaySettings
      },
      {
        path: '/distributorcustom',
        name: 'DistributorCustom',
        component: DistributorCustom
      },
      {
        path: '/goodslist',
        name: 'GoodsList',
        component: GoodsList
      },
      {
        path: '/infosynchronization',
        name: 'InfoSynchronization',
        component: InfoSynchronization
      },
      {
        path: '/infodetail',
        name: 'InfoDetail',
        component: InfoDetail
      },
      {
        path: '/infodetailed',
        name: 'InfoDetailed',
        component: InfoDetailed
      },
      {
        path: '/infoattribute',
        name: 'InfoAttribute',
        component: InfoAttribute
      },
      {
        path: '/packmanagement',
        name: 'PackManagement',
        component: PackManagement
      },
      {
        path: '/packprice',
        name: 'PackPrice',
        component: PackPrice
      },
      {
        path: '/packdetail',
        name: 'PackDetail',
        component: PackDetail
      },
      {
        path: '/distributordetail',
        name: 'DistributorDetail',
        component: DistributorDetail
      },
      {
        path: '/orderdetail',
        name: 'OrderDetail',
        component: OrderDetail
      },
      {
        path: '/storedetail',
        name: 'StoreDetail',
        component: StoreDetail
      },
      {
        path: '/selesdetail',
        name: 'SelesDetail',
        component: SelesDetail
      },
      {
        path: '/addgoods',
        name: 'AddGoods',
        component: AddGoods
      },
      {
        path: '/editgoods',
        name: 'EditGoods',
        component: EditGoods
      },
      {
        path: '/warehouseinfo',
        name: 'WarehouseInfo',
        component: WarehouseInfo
      },
      {
        path: '/pointwarehouse',
        name: 'PointWarehouse',
        component: PointWarehouse
      },
      {
        path: '/adddistributor',
        name: 'AddDistributor',
        component: AddDistributor
      },
      {
        path: '/editdistributor',
        name: 'EditDistributor',
        component: EditDistributor
      },
      {
        path: '/relatedgoods',
        name: 'RelatedGoods',
        component: RelatedGoods
      },
      {
        path: '/rolelist',
        name: 'RoleList',
        component: RoleList
      },
      {
        path: '/orderreviewdetail',
        name: 'OrderReviewDetail',
        component: OrderReviewDetail
      },
      {
        path: '/classmanagement',
        name: 'ClassManagement',
        component: ClassManagement
      },
      {
        path: '/productlogomanagement',
        name: 'ProductLogoManagement',
        component: ProductLogoManagement
      },
      {
        path: '/productPageManagement',
        name: 'ProductPageManagement',
        component: ProductPageManagement
      },
      {
        path: '/productbannermanagement',
        name: 'ProductBannerManagement',
        component: ProductBannerManagement
      },
      {
        path: '/addagreement',
        name: 'AddAgreement',
        component: AddAgreement
      },
      {
        path: '/contractreviews',
        name: 'contractReviews',
        component: contractReviews
      },
      {
        path: '/depositreviews',
        name: 'depositReviews',
        component: depositReviews
      },
      {
        path: '/outboundreviews',
        name: 'OutboundReviews',
        component: OutboundReviews
      },
      {
        path: '/editoutbound',
        name: 'EditOutbound',
        component: EditOutbound
      },

      {
        path: '/outboundlist',
        name: 'OutboundList',
        component: OutboundList
      },
      {
        path: '/toporderaddlist',
        name: 'topOrderAddList',
        component: topOrderAddList
      }, {
        path: '/toporderaddlistmodify',
        name: 'topOrderAddListModify',
        component: topOrderAddListModify
      },
      {
        path: '/topreviews',
        name: 'topReviews',
        component: topReviews
      },
      {
        path: '/topList',
        name: 'topList',
        component: topList
      },
      // 合同&&保证金
      {
        path: '/depositcash',
        name: 'DepositCash',
        component: DepositCash
      },
      {
        path: '/contractreviewlist',
        name: 'ContractReviewList',
        component: ContractReviewList
      },
      {
        path: '/contractreviewdetail',
        name: 'ContractReviewDetail',
        component: ContractReviewDetail
      },
      {
        path: '/contractList',
        name: 'ContractList',
        component: ContractList
      },
      {
        path: '/depositlist',
        name: 'depositList',
        component: depositList
      },
      {
        path: '/bank',
        name: 'Bank',
        component: Bank
      },
      {
        path: '/giftActivities',
        name: 'GiftActivities',
        component: () => import('@/components/GiftActivities')
      },
      {
        path: '/modifyActivities',
        name: 'ModifyActivities',
        component: () => import('@/components/GiftActivities/components')
      },
      {
        path: '/activityDetail',
        name: 'ActivityDetail',
        component: () => import('@/components/GiftActivities/activityDetail')
      },
      {
        path: '/order-report',
        name: 'OrderReport',
        component: () => import('@/components/OrderReport')
      },
      {
        path: '/tenant',
        name: 'Tenant',
        component: () => import('@/components/Tenant')
      },
      {
        path: '/department',
        name: 'Department',
        component: () => import('@/components/Department')
      },
      {
        path: '/regional',
        name: 'Regional',
        component: () => import('@/components/Regional')
      },
      {
        path: '/partition',
        name: 'Partition',
        component: () => import('@/components/Partition')
      },
      {
        path: '/district',
        name: 'District',
        component: () => import('@/components/District')
      }
    ]
  },
    // PC商城设置
  {
    path: '/mallsettingmenu',
    name: 'MallSettingMenu',
    component: MallSettingMenu,
    redirect: '/goodsshelves',
    children: [{
      path: '/logomanagement',
      name: 'LogoManagement',
      component: LogoManagement
    },
    {
      path: '/bannermanagement',
      name: 'BannerManagement',
      component: BannerManagement
    },
    {
      path: '/topnavsetting',
      name: 'TopNavSetting',
      component: TopNavSetting
    },
    {
      path: '/classifiedmanagement',
      name: 'ClassifiedManagement',
      component: ClassifiedManagement
    },
    {
      path: '/pagemanagement',
      name: 'PageManagement',
      component: PageManagement
    },
    {
      path: '/goodsshelves',
      name: 'GoodsShelves',
      component: GoodsShelves
    },
    {
      path: '/goodsshelvesdetail',
      name: 'GoodsShelvesDetail',
      component: GoodsShelvesDetail
    },
    {
      path: '/associatedgoods',
      name: 'AssociatedGoods',
      component: AssociatedGoods
    },
    {
      path: '/giftInventory',
      name: 'GiftInventory',
      component: () => import('@/components/MallPageSetting/giftInventory')
    }
    ]
  },
    // 线下门店设置
  {
    path: '/o2osettingmenu',
    name: ' O2OSettingMenu',
    component: O2OSettingMenu,
    redirect: '/o2ogoodsshelves',
    children: [{
      path: '/o2ologomanagement',
      name: 'O2OLogoManagement',
      component: O2OLogoManagement
    },
    {
      path: '/o2obannermanagement',
      name: 'O2OBannerManagement',
      component: O2OBannerManagement
    },
    {
      path: '/o2oclassifiedmanagement',
      name: 'O2OClassifiedManagement',
      component: O2OClassifiedManagement
    },
    {
      path: '/o2opagemanagement',
      name: 'O2OPageManagement',
      component: O2OPageManagement
    },
    {
      path: '/o2ogoodsshelves',
      name: 'O2OGoodsShelves',
      component: O2OGoodsShelves
    },
    {
      path: '/o2ogoodsshelvesdetail',
      name: 'O2OGoodsShelvesDetail',
      component: O2OGoodsShelvesDetail
    },
    {
      path: '/o2oassociatedgoods',
      name: 'O2OAssociatedGoods',
      component: O2OAssociatedGoods
    }
    ]
  }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js